export default "__VITE_ASSET__C30oE0J8__"